import React, {useEffect, useMemo} from "react";
import {Form} from "react-bootstrap";
import Select from "react-select";
import {Controller, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {setLanguage} from "../../redux/languageSlice";
import {languageOptions} from "../../dummyData/dummyData";

function LanguageDropDown() {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.language.language);

  const {control, setValue} = useForm({
    defaultValues: {
      language: selectedLanguage || null,
    },
  });

  // keep RHF synced with redux (important)
  useEffect(() => {
    setValue("language", selectedLanguage || null, {shouldDirty: false});
  }, [selectedLanguage, setValue]);

  const handleLanguageChanged = (selectedOption) => {
    if (!selectedOption) return;

    const selectedPaperValue = localStorage.getItem("paperValue") || "first";
    localStorage.removeItem(`selectedAnswers_${selectedPaperValue}`);
    localStorage.removeItem(`timeLeft_${selectedPaperValue}`);
    localStorage.removeItem(`selectedAnswersOBO_${selectedPaperValue}`);
    localStorage.removeItem(`oBOTimeLeft_${selectedPaperValue}`);

    dispatch(setLanguage(selectedOption));
  };

  const customStyles = useMemo(
    () => ({
      control: (base, state) => ({
        ...base,
        minHeight: 38,
        minWidth: 110,
        borderRadius: 999,
        paddingLeft: 6,
        paddingRight: 6,
        backgroundColor: state.isFocused ? "#ffffff" : "#f4f4f6",
        borderColor: state.isFocused ? "#0f172a" : "rgba(15, 23, 42, 0.12)",
        borderWidth: 1,
        borderStyle: "solid",
        boxShadow: state.isFocused ? "0 0 0 3px rgba(15, 23, 42, 0.08)" : "none",
        transition: "all 180ms ease",
        cursor: "pointer",
        ":hover": {
          borderColor: "rgba(15, 23, 42, 0.28)",
          backgroundColor: "#eeeef0",
        },
      }),
      valueContainer: (base) => ({
        ...base,
        padding: "0 4px 0 10px",
      }),
      singleValue: (base) => ({
        ...base,
        color: "#0f172a",
        fontWeight: 600,
        fontSize: 13.5,
        whiteSpace: "nowrap",
      }),
      placeholder: (base) => ({
        ...base,
        color: "rgba(15, 23, 42, 0.55)",
        fontWeight: 600,
        fontSize: 13.5,
        whiteSpace: "nowrap",
      }),
      indicatorSeparator: () => ({display: "none"}),
      dropdownIndicator: (base, state) => ({
        ...base,
        padding: "0 8px 0 2px",
        color: "rgba(15, 23, 42, 0.55)",
        transition: "transform 220ms ease",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
        ":hover": {color: "rgba(15, 23, 42, 0.85)"},
      }),
      menu: (base) => ({
        ...base,
        marginTop: 8,
        borderRadius: 14,
        overflow: "hidden",
        backgroundColor: "#ffffff",
        border: "1px solid #eef0f2",
        boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
        minWidth: 140,
        zIndex: 1050,
      }),
      option: (base, state) => ({
        ...base,
        cursor: "pointer",
        fontWeight: 600,
        fontSize: 13.5,
        padding: "9px 12px",
        color: "#0f172a",
        backgroundColor: state.isSelected
          ? "#0f172a"
          : state.isFocused
          ? "#f4f4f6"
          : "transparent",
        ...(state.isSelected && {color: "#ffffff"}),
        ":active": {backgroundColor: state.isSelected ? "#0f172a" : "#e5e7eb"},
      }),
    }),
    []
  );

  return (
    <Form className="d-flex justify-content-center">
      <Controller
        name="language"
        control={control}
        render={({field}) => (
          <Select
            {...field}
            inputId="language"
            className="languageSelectPremium"
            classNamePrefix="languageSelectPremium"
            options={languageOptions}
            placeholder="Language"
            styles={customStyles}
            value={selectedLanguage || null}
            onChange={(opt) => {
              field.onChange(opt);
              handleLanguageChanged(opt);
            }}
            isSearchable={false}
          />
        )}
      />
    </Form>
  );
}

export default LanguageDropDown;
